/**
 * Dosya durum listesi
 */
export const stateList = [
  { value: 1, label: 'Analiz ediliyor', color: 'bg-yellow-100 text-yellow-800', icon: 'pending' },
  { value: 2, label: 'Hazır', color: 'bg-green-100 text-green-800', icon: 'check_circle' },
  { value: 3, label: 'Hata', color: 'bg-red-100 text-red-800', icon: 'error' },
]

/**
 * Durum metni döndürür
 *
 * @param {Number|String} val - Durum ID'si
 * @returns {String} Durum metni
 */
export const getStateText = (val) => {
  if (!val) return 'Bilinmiyor'
  const stateVal = Number(val) // String veya number olabilir, number'a çevir
  return stateList.find(r => r.value === stateVal)?.label || 'Bilinmiyor'
}

/**
 * Durum renk sınıfını döndürür
 *
 * @param {Number|String} val - Durum ID'si
 * @returns {String} CSS renk sınıfı
 */
export const getStateColor = (val) => {
  if (!val) return 'bg-gray-100 text-gray-600'
  const stateVal = Number(val) // String veya number olabilir, number'a çevir
  return stateList.find(r => r.value === stateVal)?.color || 'bg-gray-100 text-gray-600'
}

/**
 * Durum simge adını döndürür
 *
 * @param {Number|String} val - Durum ID'si
 * @returns {String} Material icon adı
 */
export const getStateIcon = (val) => {
  if (!val) return ''
  const stateVal = Number(val) // String veya number olabilir, number'a çevir
  return stateList.find(r => r.value === stateVal)?.icon || ''
}

/**
 * Tüm durumları döndürür
 *
 * @returns {Array} Durumlar listesi
 */
export const getStateList = () => {
  return stateList
}